import React, { useEffect, useState } from "react";
import { api } from "../../../../../../utility/api";
import { NotificationManager } from "react-notifications";
import { getResponseError } from "../../../../../../utility/getErrors";

const url = 'comparativo_mp_ventas';

export const useApi = () => {
    const [loading, setLoading] = useState(false);
    const [dollarExchange, setDollarExchange] = useState(7.8);

    useEffect(() => {
        getDollarExchange();
    }, []);

    const guardarReporte = async (data, onSuccess) => {
        setLoading(true);
        await api.post(`${url}/save_comparativo_mp_ventas`, data).then(async () => {
            NotificationManager.success('Reporte guardado', 'Éxito', 3000);
            await getReporte(onSuccess);
        }).catch((error) => {
            const elError = getResponseError(error, 'Error al guardar reporte');
            NotificationManager.error(elError, 'ERROR', 3000);
        }).finally(() => {
            setLoading(false);
        });
    }

    const getReporte = async (onSuccess) => {
        setLoading(true);
        await api.get(`${url}/get_tables_comparativo_mp_ventas`).then((response) => {
            if (onSuccess) onSuccess(response);
        }).catch((error) => {
            const elError = getResponseError(error, 'Error en la carga de datos');
            NotificationManager.error(elError, 'ERROR', 3000);
        }).finally(() => {
            setLoading(false);
        });
    }

    const getDollarExchange = async () => {
        await api.get(`administrative/get_dollar_exchange`).then((response) => {
            setDollarExchange(response.dollar_exchange);
        }).catch((error) => {
            const elError = getResponseError(error, 'Error en la carga de datos');
            NotificationManager.error(elError, 'ERROR', 3000);
        });
    }

    return {
        guardarReporte,
        getReporte,
        loading,
        dollarExchange
    }
}
